import * as yup from "yup";

export default yup.object().shape({
  name: yup.string().required("Partner Name is required!"),
  cui: yup.string().required("Partner CUI is required!"),
  email: yup.string().required("Partner email address is required!").email(),
  phone: yup.string().required("Phone phone number is required!")
});
